import React from 'react';
import './Title.scss'

export interface UHCSidebarTitleProps{
    text:string
}

const UHCSidebarTitle: React.FC<UHCSidebarTitleProps> = (props: UHCSidebarTitleProps) => {
    return(
        <span className="sidebar-title">{props.text}</span>
    )   
}

export default UHCSidebarTitle;